import Duck from "redux-ducks-ts"

export const reference = new Duck("reference", "cargo")
